import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay]);

export const swipers = () => {
    new Swiper('.js-first-section-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
    })
    const swiper = new Swiper('.js-advertising-swiper', {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-buttons-custom__btn--next',
            prevEl: '.swiper-buttons-custom__btn--prev',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        on: {
            init(swiper) {
                const {slides} = swiper;

                if (slides.length <= 1) {
                    const nextEl = swiper.navigation.nextEl;
                    const prevEl = swiper.navigation.prevEl;
                    const hideEl = (el) => {
                        if (!el) return;
                        if (Array.isArray(el)) {
                            el.forEach((item) => (item.style.display = 'none'));
                        } else {
                            el.style.display = 'none';
                        }
                    };

                    hideEl(nextEl);
                    hideEl(prevEl);
                }
            },
        },
    });
    const swiperCases = new Swiper('.js-cases-swiper', {
        slidesPerView: 1.07,
        spaceBetween: 15,
        pagination: {
            el: '.cases-section__pagination',
            clickable: true,
        },
        breakpoints: {
            568: {
                slidesPerView: 1.337,
            },
        },
    });
    document.querySelectorAll('.js-cases-inner-swiper').forEach(el => {
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 15,
            allowTouchMove: false,
            navigation: {
                nextEl: el.querySelector('.swiper-buttons-custom__btn--next'),
                prevEl: el.querySelector('.swiper-buttons-custom__btn--prev')
            },
            on: {
                init(swiper) {
                    const {slides} = swiper;

                    if (slides.length <= 1) {
                        const nextEl = swiper.navigation.nextEl;
                        const prevEl = swiper.navigation.prevEl;
                        const hideEl = (el) => {
                            if (!el) return;
                            if (Array.isArray(el)) {
                                el.forEach((item) => (item.style.display = 'none'));
                            } else {
                                el.style.display = 'none';
                            }
                        };

                        hideEl(nextEl);
                        hideEl(prevEl);
                    }
                },
            },
        });
    });
    // const swiperCasesInner = new Swiper('.js-cases-inner-swiper', {
    //     slidesPerView: 1,
    //     spaceBetween: 15,
    //     navigation: {
    //         nextEl: '.swiper-buttons-custom__btn--next',
    //         prevEl: '.swiper-buttons-custom__btn--prev',
    //     },
    //     on: {
    //         init(swiper) {
    //             const {slides} = swiper;
    //
    //             if (slides.length <= 1) {
    //                 const nextEl = swiper.navigation.nextEl;
    //                 const prevEl = swiper.navigation.prevEl;
    //                 const hideEl = (el) => {
    //                     if (!el) return;
    //                     if (Array.isArray(el)) {
    //                         el.forEach((item) => (item.style.display = 'none'));
    //                     } else {
    //                         el.style.display = 'none';
    //                     }
    //                 };
    //
    //                 hideEl(nextEl);
    //                 hideEl(prevEl);
    //             }
    //         },
    //     },
    // });

}